// ProductPageOffGrid.jsx

import React from "react";
import "../ProductPage/CSS/ProductPageOffGrid.css";

const ProductPageOffGrid = () => {
  return (
    <section className="productpageoffgrid-section">
      <div className="productpageoffgrid-container">
        <h2>
          What is an Off-Grid
        </h2>

        <p>
          An Off-Grid solar system is a standalone energy solution that
          generates and stores electricity without relying on the public grid.
          It uses solar panels to produce power and batteries to store it for
          use during nights or power outages.
        </p>
      </div>
    </section>
  );
};

export default ProductPageOffGrid;